import _paTranslations from './pa.json';

const translation = {
  ..._paTranslations,
};

export default translation;
